import { Component, ChangeDetectionStrategy, inject } from '@angular/core';
import { PopoverRef } from '../popover/popover-ref';
import { MatRipple } from '@angular/material/core';
import { RouterLink } from '@angular/router';
import { MatIcon } from '@angular/material/icon';

@Component({
	selector: 'vex-user-menu',
	templateUrl: './user-menu.component.html',
	styleUrls: ['./user-menu.component.scss'],
	changeDetection: ChangeDetectionStrategy.Eager,
	imports: [MatRipple, RouterLink, MatIcon],
})
export class UserMenuComponent {
	private readonly popoverRef = inject(PopoverRef);

	close(): void {
		/** Wait for animation to complete and then close */
		setTimeout(() => this.popoverRef.close(), 250);
	}
}
